"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleAddressSchema = void 0;
const zod_1 = require("zod");
const StreetTypes_1 = require("../enums/StreetTypes");
const SecondaryUnitTypes_1 = require("../enums/SecondaryUnitTypes");
const constants_1 = require("../constants");
const StateCodes_1 = require("../enums/StateCodes");
exports.impossibleAddressSchema = zod_1.z.object({
    raw: constants_1.defaultOptionalString,
    number: zod_1.z.optional(zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(10).regex(constants_1.REGEX.addressNumber)),
    street: zod_1.z.optional(zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(40).regex(constants_1.REGEX.addressStreet)),
    type: zod_1.z.optional(zod_1.z.nativeEnum(StreetTypes_1.StreetTypes)),
    city: zod_1.z.optional(zod_1.z
        .string()
        .min(constants_1.MIN_DEFAULT_STRING_LENGTH)
        .max(36)
        .regex(constants_1.REGEX.unicodeLettersSeparatedBySpacesOrHyphens)),
    state: zod_1.z.optional(zod_1.z.nativeEnum(StateCodes_1.StateCodes)),
    zip: zod_1.z.optional(zod_1.z.string().length(5).regex(constants_1.REGEX.digitsOnly)),
    sec_unit_type: zod_1.z.optional(zod_1.z.nativeEnum(SecondaryUnitTypes_1.SecondaryUnitTypes)),
    sec_unit_num: zod_1.z.optional(zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(10).regex(constants_1.REGEX.nonWhiteSpace)),
    plus4: zod_1.z.optional(zod_1.z.string().length(4).regex(constants_1.REGEX.digitsOnly)),
    suffix: zod_1.z.optional(zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(16).regex(constants_1.REGEX.defaultString)),
    prefix: zod_1.z.optional(zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(16).regex(constants_1.REGEX.defaultString)),
    country: zod_1.z.optional(zod_1.z.nullable(zod_1.z.string().min(2).max(constants_1.MAX_DEFAULT_STRING_LENGTH))),
}).strict();
